export const zIndices = {
  thead: 10,
  datepicker: 11,
  multiSelect: 49,
  menu: 50,
  tooltip: 999999,
};
